import React from 'react';
import { connect } from 'react-redux';
import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/api.form.actions';

import Hidden from '@material-ui/core/Hidden';

import Group from './Group';
import Field from './Field';
import Instance from './Instance';

class Form extends React.Component {
    render() {
        const { elements, hide, editable, tab, parentDeactivated, instancia } = this.props;
        return (
            <div className={'flex_full_column padding_bottom_9'}>
                {instancia && (
                    <Hidden smUp>
                        <div className="flex_full_row padding_top_12 bg_cloudy_blue_30">
                            <Instance key={randomstring()} info={instancia} />
                        </div>
                    </Hidden>
                )}
                <div
                    id={tab}
                    name="form_fields_process"
                    className="flex_full padding_left_12 padding_top_12 padding_right_24"
                >
                    {elements &&
                        elements.hijos &&
                        elements.hijos.map((info, i) => {
                            if (info.hijos && info.hijos.length > 0) {
                                return (
                                    <Group
                                        key={info.codigo}
                                        {...this.props}
                                        data={info}
                                        last={elements.hijos.length === i + 1}
                                        hide={hide}
                                        editable={editable}
                                        parentDeactivated={parentDeactivated}
                                    />
                                );
                            } else {
                                return (
                                    <Field
                                        key={info.codigo}
                                        data={info}
                                        hide={hide}
                                        editable={editable}
                                        last={elements.hijos.length === i + 1}
                                        parentDeactivated={parentDeactivated}
                                    />
                                );
                            }
                        })}
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    undefined,
    mapDispatchToProps,
)(Form);



// WEBPACK FOOTER //
// ./src/components/complex/forms/Form.js